/**
 * VariantGate — show/hide UI based on the current app mode (CCA/EIA).
 *
 * This is the idiomatic way to branch the UI between variants. Prefer it over
 * `if (mode === 'cca')` scattered in JSX, and NEVER fork a whole component/route
 * per variant — that reintroduces the duplication this architecture avoids.
 *
 * Usage:
 *   <VariantGate only="eia"><SustainabilityCard /></VariantGate>
 *   <VariantGate not="eia"><LegacyNote /></VariantGate>
 *   <VariantGate only={['cca','eia']} fallback={<Empty/>}>...</VariantGate>
 */
import { useAppMode } from './useAppMode';

function toArray(v) {
  if (v == null) return null;
  return Array.isArray(v) ? v : [v];
}

export function VariantGate({ only, not, fallback = null, children }) {
  const { mode } = useAppMode();
  const onlyList = toArray(only);
  const notList = toArray(not);

  if (onlyList && !onlyList.includes(mode)) return fallback;
  if (notList && notList.includes(mode)) return fallback;
  return children;
}

export default VariantGate;
